import React, { useState } from 'react';
import vitroLogo from '../Public/Images/vitroSimple.png';
import './Products.css';

function Products() {
    const privateProductData = [
        {
            name: 'VitroAI™',
            image: '/images/vitro_x.png',
            description: 'VitroAI™ is a modern hyperconverged infrastructure (HCI) platform designed to replace legacy solutions like VMware and Nutanix. It offers a secure, scalable, and cost-effective foundation for virtualized workloads, optimized for federal and enterprise environments. With automated provisioning, robust security features compliant with DoD STIG standards, and seamless integration with Kubernetes, VitroAI™ simplifies infrastructure management while delivering high performance and resilience in both standard and ruggedized deployments.',
            link: '/vitro'
        },
        {
            name: 'Federal Frontier Kubernetes Platform™ (FKP)',
            image: '/images/federal_frontier_x.png',
            description: 'The Federal Frontier Kubernetes Platform™ (FKP) is an open, subscription-based solution for streamlined Kubernetes cluster lifecycle management. Leveraging the Kubernetes Cluster API (CAPI), FKP enables rapid deployment, scaling, and maintenance of clusters across cloud, on-premises, and edge environments. Tailored for federal compliance, it includes FIPS-140-2 encryption, Calico Enterprise for network isolation, and long-term support for security updates, ensuring a secure and flexible platform for mission-critical workloads.',
            link: '/fkp'
        },
        {
            name: 'Day 2 Applications',
            image: '/images/federal_frontier_x.png',
            description: 'Day 2 Applications provide a suite of integrated tools for observability, compliance, and operational excellence in Kubernetes environments. Featuring Grafana dashboards for real-time monitoring, automated compliance checks aligned with CIS benchmarks, and seamless integration with Netris for network management, these apps empower organizations to maintain control and efficiency. Designed for both enterprise and federal use cases, Day 2 Applications reduce operational complexity and enhance system reliability.',
            link: '/day2apps'
        },
        {
            name: 'Fedstryke',
            image: '/images/federal_frontier_x.png',
            description: 'Fedstryke is a secure, mission-focused solution tailored for federal and enterprise edge deployments. It provides hardened networking, rapid provisioning patterns, and compliance-oriented tooling optimized for constrained and disconnected environments.',
            link: '/fedstryke'
        },
        // {
        //     name: 'OutpostAI (F3Iai)',
        //     image: '/images/outpostAI_x.png',
        //     description: 'Mock product page for OutpostAI / F3Iai. Content intentionally placeholder.',
        //     link: '/outpostai'
        // }
    ];

    const [selectedProduct, setSelectedProduct] = useState(privateProductData[0]);
    const [isFullScreenOpen, setIsFullScreenOpen] = useState(false);

    const handleProductChange = (product) => {
        setSelectedProduct(product);
    };

    const handleImageClick = () => {
        setIsFullScreenOpen(true);
    };

    const handleCloseFullScreen = () => {
        setIsFullScreenOpen(false);
    };

    return (
        <div className="products-page">
            <section className="overview-section">
                <div className="overview-content">
                    <h1>Federal Frontier Portfolio</h1>
                    <p>Discover VitroAI™, FKP™, and Day 2 Applications—secure, compliant, and cost-effective solutions for modern infrastructure, Kubernetes management, and operational excellence.</p>
                </div>
            </section>
            <div className="quick-look-steps">
                <div className="quick-look-step">
                    <img src="/images/innovation-art.png" alt="Rapid Deployment" />
                    <p>Rapid Deployment</p>
                </div>
                <div className="quick-look-step">
                    <img src="/images/shield-art.png" alt="Reliability" />
                    <p>Ensuring Stability</p>
                </div>
                <div className="quick-look-step">
                    <img src="/images/lock-art.png" alt="Security" />
                    <p>Establishing Security</p>
                </div>
                <div className="quick-look-step">
                    <img src="/images/revenue-art.png" alt="Return on Investment" />
                    <p>Rapid Return on Investment</p>
                </div>
            </div>
            <div className="product-tabs">
                {privateProductData.map((product) => (
                    <div
                        key={product.name}
                        className={`product-tab ${product.name === selectedProduct.name ? 'active' : ''}`}
                        onClick={() => handleProductChange(product)}
                    >
                        {product.name}
                    </div>
                ))}
            </div>
            <div className="quick-look-diagram-container">
                <div className="quick-look-left">
                    <div className="quick-look-image">
                        <img src={selectedProduct.image} alt={selectedProduct.name} />
                    </div>
                    <div className="quick-look-text">
                        <a href={selectedProduct.link} style={{ textDecoration: 'none', color: 'inherit' }}>
                            <h2>{selectedProduct.name}</h2>
                        </a>
                        <p>{selectedProduct.description}</p>
                        <a href={selectedProduct.link} className="learn-more-button">Learn More</a>
                    </div>
                </div>
                <div className="quick-look-diagram">
                    <img src="/images/ff-platform-diagram.png" alt="Federal Frontier Platform Diagram" onClick={handleImageClick} style={{ cursor: 'pointer' }} />
                </div>
            </div>
            {isFullScreenOpen && (
                <div className="full-screen-overlay" onClick={handleCloseFullScreen}>
                    <div className="full-screen-content" onClick={(e) => e.stopPropagation()}>
                        <button className="full-screen-close" onClick={handleCloseFullScreen}>&times;</button>
                        <img src="/images/ff-platform-diagram.png" alt="Federal Frontier Platform Diagram Full Screen" />
                    </div>
                </div>
            )}
        </div>
    );
}

export default Products;